// extracted by mini-css-extract-plugin
module.exports = {"list":"social-media-link-list_list__ea7PF"};